import { gql } from 'graphql-tag'

import { FRAGMENT_AVATAR_USER } from '@/components/Worlds/UI/Avatar/Avatar.hasura'

export const FRAGMENT_CONVERSATION_MEMBERS_MODAL_CONVERSATION = gql`
  fragment ConversationMembersModalConversation on conversation {
    conversation_users {
      user {
        id
        username
        ...AvatarUser
      }
    }
  }
  ${FRAGMENT_AVATAR_USER}
`
